import { render, staticRenderFns } from "./ManagePremiereProfile.vue?vue&type=template&id=d1b6086a&scoped=true"
import script from "./ManagePremiereProfile.vue?vue&type=script&lang=js"
export * from "./ManagePremiereProfile.vue?vue&type=script&lang=js"
import style0 from "./ManagePremiereProfile.vue?vue&type=style&index=0&id=d1b6086a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b6086a",
  null
  
)

export default component.exports